module.exports = __webpack_public_path__ + "static/media/home-bg-tablet-low.1b489fa0.jpg";